module.exports = __webpack_public_path__ + "img/TrafficInformation.03948053.svg";